import { render, staticRenderFns } from "./ChamadasForm.vue?vue&type=template&id=6a596440&scoped=true"
import script from "./ChamadasForm.vue?vue&type=script&lang=js"
export * from "./ChamadasForm.vue?vue&type=script&lang=js"
import style0 from "./ChamadasForm.vue?vue&type=style&index=0&id=6a596440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a596440",
  null
  
)

export default component.exports